module.exports = __webpack_public_path__ + "img/premium-slider-4.8f3ab29a.png";